import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import guardRouter from './guard';

Vue.use(VueRouter)

// meta.hideHeader:移动端隐藏Header
// meta.hideFooter:移动端隐藏Footer

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页'
    }
  },
  // 个人中心
  {
    path: '/center',
    name: 'center',
    component: () => import('@/views/UserCenter/index.vue'),
    meta: {
      title: '个人中心',
      hideHeader: true,
      auth: true,
    }
  },
  // 用户协议隐私协议
  {
    path: '/article/:protocol?',
    name: 'article',
    component: () => import('@/views/article.vue'),
    meta: {
      title: '用户协议与隐私政策',
      hideHeader: true,
    }
  },
  // 服务公告列表
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/views/Notices/index.vue'),
    meta: {
      title: '服务公告',
    }
  },
  // 服务公告详情页
  {
    path: '/notice/detail/:id',
    name: 'notice-detail',
    component: () => import('@/views/Notices/detail.vue'),
    meta: {
      title: '公告详情',
    }
  },
  // 我的订单
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/views/Order/index.vue'),
    meta: {
      title: '我的订单',
      hideHeader: true,
      auth: true,
    }
  },
  // 我的订单
  {
    path: '/orders/pay',
    name: 'order-pay',
    component: () => import('@/views/Order/pay.vue'),
    meta: {
      title: '订单支付',
      hideHeader: true,
      auth: true,
    }
  },
  // 我的订单
  {
    path: '/orders/detail/:id',
    name: 'orders-detail',
    component: () => import('@/views/Order/detail.vue'),
    meta: {
      title: '我的订单详情',
      hideHeader: true,
      hideFooter: true,
      auth: true,
    }
  },
  // 核对订单
  {
    path: '/orders/check/:id?',
    name: 'orders-check',
    component: () => import('@/views/Order/check.vue'),
    meta: {
      title: '核对订单',
      hideHeader: true,
      hideFooter: true,
      auth: true,
    }
  },
  // 新增收货地址
  {
    path: '/addAddress',
    name: 'add-address',
    component: () => import('@/views/addAddress.vue'),
    meta: {
      title: '新增收货地址',
      hideHeader: true,
      hideFooter: true,
      auth: true,
    }
  },
  // 新增收货地址
  {
    path: '/address/form/:id?',
    name: 'address-form',
    component: () => import('@/views/Address/form.vue'),
    meta: {
      title: '编辑收货地址',
      hideHeader: true,
      hideFooter: true,
      auth: true,
    }
  },
  // 选择收货地址
  {
    path: '/address/choose',
    name: 'address-choose',
    component: () => import('@/views/Address/chooseAddress.vue'),
    meta: {
      title: '选择收货地址',
      hideHeader: true,
      hideFooter: true,
      auth: true,
    }
  },
  // 登录、注册
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录-注册',
      isLogin: true,
      hideFooter: true,
      hideHeader: true,
    }
  },
  // 登录、注册
  {
    path: '/change_password/:isRevise?',
    name: 'change_password',
    component: () => import('@/views/MobilePage/findPwd.vue'),
    meta: {
      title: '修改密码',
      hideFooter: true,
      hideHeader: true,
    }
  },
  // 分类列表页
  {
    path: '/goods/type/:id?',
    name: 'goods-type',
    component: () => import('@/views/Goods/type.vue'),
    meta: {
      title: '分类列表页',
    }
  },
  // 商品详情页
  {
    path: '/goods/detail/:id',
    name: 'goods-detail',
    component: () => import('@/views/Goods/detail.vue'),
    meta: {
      title: '商品详情页',
    }
  },
  // 商品购物车
  {
    path: '/shopcar',
    name: 'shopcar',
    component: () => import('@/views/ShopCar.vue'),
    meta: {
      title: '购物车',
      hideHeader: true,
      auth: true,
    }
  },
  // 发票申请
  {
    path: '/invoice/apply/:order_no',
    name: 'invoice-apply',
    component: () => import('@/views/Invoice/apply.vue'),
    meta: {
      title: '发票申请',
      hideHeader: true,
      hideFooter: true,
      auth: true,
    }
  },
  // 移动端可申请发票列表
  {
    path: '/invoice/apply/list/:order_no',
    name: 'invoice-apply-list',
    component: () => import('@/views/Invoice/mobileInvoiceList.vue'),
    meta: {
      title: '申请开具发票',
      hideHeader: true,
      hideFooter: true,
      auth: true,
    }
  },
  // 移动端发票申请表单填写
  {
    path: '/m/invoice/apply/:order_no',
    name: 'm-invoice-apply',
    component: () => import('@/views/Invoice/MobileApplyForm.vue'),
    meta: {
      title: '申请开票',
      auth: true,
      hideHeader: true,
      hideFooter: true
    }
  },
  // 已开发票
  {
    path: '/invoice/:order_no',
    name: 'invoice',
    component: () => import('@/views/Invoice/index.vue'),
    meta: {
      title: '已开发票',
      auth: true,
      hideHeader: true,
      hideFooter: true
    }
  },
  // 支付结果
  {
    path: '/pay/result/:type?',
    name: 'pay-result',
    component: () => import('@/views/PayResult.vue'),
    meta: {
      auth: true,
      title: '支付结果',
      hideHeader: true,
      hideFooter: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局路由守卫
guardRouter(router);

export default router
